import type { FC } from 'react';
import React, { useContext, useState } from 'react';
import { ModalContext, RicosContext } from 'ricos-context';
import type { IToolbarItem } from 'ricos-types';
import { EditIcon, ToggleButton } from 'wix-rich-content-toolbars-ui';

import type { InsertModalProps } from './insert-modal/InsertModal';

type Props = {
  toolbarItem: IToolbarItem;
  dataHook?: string;
  id: string;
};

export const EditHtmlButton: FC<Props> = ({ toolbarItem, dataHook, id }) => {
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext);

  const onClick = () => {
    const componentProps: InsertModalProps = {
      nodeId: toolbarItem.attributes.selectedNode.attrs.id,
      closeModal: () => modalService.closeModal(id),
    };

    const isModalOpen = modalService.isModalOpen(id);
    isModalOpen
      ? modalService.closeModal(id)
      : modalService.openModal(id, {
          componentProps,
          layout: isMobile ? 'fullscreen' : 'popover',
          positioning: { referenceElement, placement: 'bottom' },
          noPadding: true,
        });
  };

  return (
    <ToggleButton
      dataHook={dataHook}
      Icon={EditIcon}
      label={t('HtmlPlugin_EditHtml_Tooltip')}
      tooltip={t('HtmlPlugin_EditHtml_Tooltip')}
      onClick={onClick}
      setRef={setReferenceElement}
    />
  );
};
